import React, { FC, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../../../store';
import Checkout from './checkout';
import { Disclaimer } from './disclaimer';
import classNames from 'classnames';
import locales from '../../../../../content.json';
import s from './index.module.scss';
import { getParameterFromURL } from '../../../../../utils/scripts';
import { getCurrencySymbol } from '../../../../../utils/scripts/currency';
import { trackBlockScrollDepth } from '../../../../../utils/scripts/scrollTracker';

interface Props {
  label: any;
  discount?: any;
  onClose: () => void;
}

const PaymentModalV5: FC<Props> = props => {
  const { onClose } = props;
  const isPaymentModalShow = useSelector((state: RootState) => state.navigation.paymentModal.show);
  const product = useSelector((state: RootState) => state.data.paymentModal.product);
  const tariff = useSelector((state: RootState) => state.data.tariff);
  const [indexModal, setIndexModal] = useState(false);
  const firstScreenAB = getParameterFromURL('fSW') === 'true';
  const tariffURL = getParameterFromURL('tariff');
  const applePayMainMethod = false;
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    trackBlockScrollDepth(s.paymentModal, 'checkout');
    setIndexModal(true);
  }, []);

  useEffect(() => {
    if (applePayMainMethod && indexModal) {
      setIndexModal(false);
    }
  }, [applePayMainMethod, indexModal]);

  useEffect(() => {
    if (isPaymentModalShow && scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto',
      });
    }
  }, [isPaymentModalShow]);

  const handleClose = () => {
    onClose?.();
  };

  function getPeriod(product) {
    const duration = product.details.duration;

    if (duration) {
      let resultPeriodTextValue = `${duration.value} ${duration.unit}`;
      const resultTrialPeriodTextValue =
        tariff === 'v31' || tariff === 'v33'
          ? `${duration.trial_period_value} ${duration.trial_period_unit}`
          : `${duration.trial_period_value} ${duration.trial_period_unit}`;

      if (resultTrialPeriodTextValue === '1 week' || resultTrialPeriodTextValue === '7 day') {
        resultPeriodTextValue = `${locales[window.userLang].payment_text_117}`;
      }

      if (resultTrialPeriodTextValue === '1 month') {
        resultPeriodTextValue = `${locales[window.userLang].payment_text_66}`;
      }

      if (resultTrialPeriodTextValue === '3 month') {
        resultPeriodTextValue = `${locales[window.userLang].payment_text_67}`;
      }

      if (resultPeriodTextValue === '1 month') {
        resultPeriodTextValue = `${locales[window.userLang].payment_text_66}`;
      }

      if (resultPeriodTextValue === '3 month') {
        resultPeriodTextValue = `${locales[window.userLang].payment_text_67}`;
      }

      if (resultPeriodTextValue === '6 month') {
        resultPeriodTextValue = `${locales[window.userLang].payment_text_125}`;
      }

      let resultPeriodText;

      if (resultPeriodTextValue) {
        resultPeriodText = resultPeriodTextValue
          .toLowerCase()
          .replace(/-\w/g, match => match.toUpperCase())
          .replace(/^\w/, match => match.toUpperCase());
      }
      return resultPeriodText;
    }
  }

  function getPrice(product) {
    if (product) {
      const resultPriceTextValue = product?.details?.trial_amount || product?.details?.amount;

      return `${getCurrencySymbol()}${resultPriceTextValue}`;
    }
  }

  return (
    <section className={classNames(s.paymentModal, isPaymentModalShow ? s.paymentModal_shown : s.paymentModal_hide)}>
      <div className={s.paymentModal_Wrapper} ref={scrollRef}>
        <div className={s.paymentModal_header}>
          {!tariffURL && firstScreenAB ? (
            <div className={s.paymentModal_headerLogoV2} />
          ) : (
            <div className={s.paymentModal_headerLogo} />
          )}
        </div>
        <div className={s.paymentModal_content}>
          <div className={s.paymentModal_close} onClick={handleClose} aria-label="Close" />
          <h2
            className={s.paymentModal_title}
            dangerouslySetInnerHTML={{ __html: locales[window.userLang].checkoutV2_text9 }}
          />
          <p className={s.paymentModal_subtitle}>
            <span className={s.paymentModal_subtitleText1}>{locales[window.userLang].checkoutV2_text1}: </span>
            <span className={s.paymentModal_subtitleText2}>{product ? `${getPrice(product)} ` : ''}</span>
            <span className={s.paymentModal_subtitleText3}>{locales[window.userLang].for} </span>
            <span className={s.paymentModal_subtitleText4}>{product ? `${getPeriod(product)} ` : ''}</span>
          </p>
          <div className={s.paymentModal_contentTextBlock}>
            <p className={s.paymentModal_contentText1}>{locales[window.userLang].checkoutV2_text10}</p>
            <p className={s.paymentModal_contentText2}>
              <span />
              {locales[window.userLang].checkoutV2_text11}
            </p>
          </div>
          <Checkout product={product} />
          <div className={`${s.paymentModal_guarantee} ${applePayMainMethod ? s.grenn : ''}`}>
            <span />
            <p>{locales[window.userLang].checkoutV2_text8}</p>
          </div>
          <Disclaimer />
        </div>
      </div>
    </section>
  );
};

export default PaymentModalV5;
